import { render } from "./dock.vue?vue&type=template&id=54c81390&scoped=true"
import script from "./dock.vue?vue&type=script&lang=js"
export * from "./dock.vue?vue&type=script&lang=js"

import "./dock.vue?vue&type=style&index=0&id=54c81390&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c81390"]])

export default __exports__